import React, { useState } from 'react';

import { useIsMobileViewport } from '../../util/uiHelpers';
import { Modal } from '../../components';

import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import ListingImageGridMobile from './ListingImageGridMobile/ListingImageGridMobile';
import ImageCarousel from './ImageCarousel/ImageCarousel';
import WishlistToggle from './WishlistToggle';

import css from './ListingPage.module.css';

const IMAGE_VARIANTS = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];

const SectionGallery = props => {
  const {
    listing,
    variantPrefix,
    currentUser,
    currentListing,
    onUpdateProfile,
    onManageDisableScrolling,
  } = props;

  // Index of the photo the full-screen carousel should open on. `null` means
  // the carousel is closed.
  const [carouselIndex, setCarouselIndex] = useState(null);
  const isMobile = useIsMobileViewport();

  const images = listing.images || [];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  const isCarouselOpen = carouselIndex !== null;

  // On phones the photos are shown as one block that fits on the screen. On
  // wider screens the swipeable gallery is kept as it is.
  const showMobileGrid = isMobile && images.length > 0;

  return (
    <section className={css.productGallery} data-testid="carousel">
      {showMobileGrid ? (
        <>
          <ListingImageGridMobile
            images={images}
            imageVariants={IMAGE_VARIANTS}
            onImageClick={index => setCarouselIndex(index)}
          >
            <WishlistToggle
              currentUser={currentUser}
              currentListing={currentListing}
              onUpdateProfile={onUpdateProfile}
            />
          </ListingImageGridMobile>

          <Modal
            id="SectionGallery.imageCarousel"
            scrollLayerClassName={css.carouselModalScrollLayer}
            containerClassName={css.carouselModalContainer}
            lightCloseButton
            isOpen={isCarouselOpen}
            onClose={() => setCarouselIndex(null)}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling}
          >
            {/* The carousel only reads startIndex when it mounts, so the key
                forces a fresh one whenever another photo is tapped. */}
            <ImageCarousel
              key={carouselIndex}
              images={images}
              imageVariants={IMAGE_VARIANTS}
              startIndex={carouselIndex || 0}
            />
          </Modal>
        </>
      ) : (
        <ListingImageGallery
          images={images}
          imageVariants={IMAGE_VARIANTS}
          thumbnailVariants={thumbnailVariants}
          currentUser={currentUser}
          currentListing={currentListing}
          onUpdateProfile={onUpdateProfile}
        />
      )}
    </section>
  );
};

export default SectionGallery;
